import { selectDialog, selectForm } from "app/core/interfaces/authorization.types";
import { PaymentDetailsComponent } from "app/pages/payment/payment-details/payment-details.component";
import { ScheduleDetailsComponent } from "app/pages/schedule/status/details/schedule-details.component";
import { ScheduleStatusComponent } from "app/pages/schedule/status/schedule-status.component";

export const scheduleFilter = ['Todos','Consultas', 'Exames'];

export const procedureFilter = ['Consulta', 'Exame'];

export const encounterFilter = ['Todos','Consultas', 'Exames'];

export const tiposDialog: selectDialog[] = [
    {
        id: "payment-detail",
        name: "Pagamento",
        visible: false,
        component: PaymentDetailsComponent
    },
    {
        id: "schedule-detail",
        name: "Atendimento",
        visible: false,
        component: ScheduleDetailsComponent
    },    
    {
        id: "schedule-status",
        name: "Status",
        visible: false,
        component: ScheduleStatusComponent
    }
];